const sessionRoutes = {
  calendar: {
    path: '/calendar'
  },
  clientSessions: {
    path: '/session-history'
  },
  createSession: {
    path: '/sessions/create'
  },
  editSession: {
    path: '/sessions/edit/:id'
  },
  groupSessions: {
    path: '/group-sessions'
  },
  trainerGroupSessions: {
    path: '/trainer/group-sessions'
  },
  activePlusSessions: {
    path: '/my-group-sessions'
  },
  listSession: {
    path: '/sessions'
  }
};

export default sessionRoutes;
